export default "__VITE_ASSET__27xBzjlk__"